import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Tooltip,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Divider,
  useMediaQuery,
  Link,
} from '@material-ui/core';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { makeStyles, Theme } from '@material-ui/core/styles';
import FiberManualRecordSharpIcon from '@material-ui/icons/FiberManualRecordSharp';

import vrbo from 'src/App/assets/vrbo_logo_sm.jpg';
import tripadvisor from 'src/App/assets/tripadvisor.svg';
import booking_com from 'src/App/assets/booking_com.jpg';
import { COLOR_PRIMARY_1 } from 'src/utils/colors';

const useStylesRoot = makeStyles({
  tooltip: {
    padding: 0,
    width: 400,
  },
});

// {data.room_type}
const SimplePointer = ({ lat, lng, data }: { lat: number; lng: number; data: any }) => {
  const matches = useMediaQuery('(max-width:550px)');

  const [tooltipOpen, setTooltipOpen] = useState<boolean>(false);

  const rootClass = useStylesRoot();

  const icon = (
    <FiberManualRecordSharpIcon
      style={{ fontSize: 10, color: COLOR_PRIMARY_1 }}
      onMouseLeave={() => {
        setTooltipOpen(false);
      }}
      onClick={() => {
        setTooltipOpen(prev => !prev);
      }}
    />
  );

  let tagIcon = vrbo;

  if (data.channel === 'booking_com') {
    tagIcon = booking_com;
  } else if (data.channel === 'tripadvisor') {
    tagIcon = tripadvisor;
  }

  return (
    <>
      <ClickAwayListener onClickAway={() => setTooltipOpen(false)}>
        <Tooltip
          interactive
          classes={rootClass}
          open={tooltipOpen}
          onOpen={() => setTooltipOpen(true)}
          onClose={() => {
            !matches && setTooltipOpen(false);
          }}
          style={{ zIndex: 999999 }}
          title={
            <Card>
              <Link href={'https://www.' + data.listing_url} target="_blank" rel="nofollow">
                <CardMedia
                  component="img"
                  alt={data.name}
                  height="140"
                  image={data.thumbnail_url}
                  title={data.name}
                  style={{ zIndex: 999999 }}
                />
              </Link>

              {/* Origin Tag */}
              <div
                style={{
                  background: '#fff',
                  padding: '5px 15px',
                  borderRadius: 100,
                  position: 'absolute',
                  top: '30px',
                  left: '10px',
                }}
              >
                <img src={tagIcon} style={{ height: '15px', marginTop: '5px' }} />
              </div>

              <CardContent style={{ zIndex: 999999 }}>
                <Typography component={'div'} variant={'h6'} style={{ marginBottom: '10px' }}>
                  {data.name}
                </Typography>

                <Divider />

                <Grid
                  container
                  xs={12}
                  justifyContent="space-between"
                  style={{ marginTop: '10px' }}
                >
                  <Grid item>
                    <Typography>Number of Reviews</Typography>
                  </Grid>
                  <Grid item>
                    <Typography>{data.review_count >= 0 ? data.review_count : 'NA'}</Typography>
                  </Grid>
                </Grid>

                <Grid
                  container
                  xs={12}
                  justifyContent="space-between"
                  style={{ marginTop: '10px' }}
                >
                  <Grid item>
                    <Typography>Rating</Typography>
                  </Grid>
                  <Grid item>
                    <Typography>{data.rating >= 0 ? data.rating : 'NA'}</Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          }
        >
          {icon}
        </Tooltip>
      </ClickAwayListener>
    </>
  );
};

export default React.memo(SimplePointer);
